module.exports = __webpack_public_path__ + "img/update_inbox.a4f4d37e.svg";